import React, { useState } from "react";
import { Form, Button, Card, Container, Alert } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import "./UserLogin.css"; // same styling as before

const UserLogin = () => {
  const navigate = useNavigate();

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");

  const handleLogin = (e) => {
    e.preventDefault();

    // Fake login logic (replace with real user API)
    if (email === "user@example.com" && password === "user123") {
      localStorage.setItem("token", "user-token");
      navigate("/dashboard"); // or navigate("/user-home") etc.
    } else {
      setError("Invalid user credentials");
    }
  };

  return (
    <div className="login-bg">
      <Container className="d-flex justify-content-center align-items-center min-vh-100">
        <Card className="login-card p-4">
          <h3 className="text-center mb-3">User Login</h3>
          {error && <Alert variant="danger">{error}</Alert>}
          <Form onSubmit={handleLogin}>
            <Form.Group className="mb-3" controlId="formEmail">
              <Form.Label>Email address</Form.Label>
              <Form.Control
                type="email"
                placeholder="Enter email"
                value={email}
                required
                onChange={(e) => setEmail(e.target.value)}
              />
            </Form.Group>

            <Form.Group className="mb-3" controlId="formPassword">
              <Form.Label>Password</Form.Label>
              <Form.Control
                type="password"
                placeholder="Password"
                value={password}
                required
                onChange={(e) => setPassword(e.target.value)}
              />
            </Form.Group>

            <Button variant="success" type="submit" className="w-100">
              Login
            </Button>

            <div className="text-center mt-3">
              <a href="/forget-password">Forgot Password?</a>
            </div>
          </Form>
        </Card>
      </Container>
    </div>
  );
};

export default UserLogin;
